import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	base: '/',
	routes: [
		{
			path: '/history',
			name: 'history',
			component: () => import('@/components/faqi/history.vue'),
			meta: {
				title: '销售列表',
				keepAlive: false
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('@/components/faqi/login.vue'),
			meta: {
				title: 'login',
				keepAlive: false
			}
		},
		{
			path: '/add-sale',
			name: 'add-sale',
			component: () => import('@/components/faqi/add-sale.vue'),
			meta: {
				title: '新增',
				keepAlive: false
			}
		},
		{
			path: '/wxjl',
			name: 'wxjl',
			component: () => import('@/components/faqi/wxjl.vue'),
			meta: {
				title: '维修记录',
				keepAlive: false
			}
		},
		{
			path: '/add-maintenance',
			name: 'add-maintenance',
			component: () => import('@/components/faqi/add-maintenance.vue'),
			meta: {
				title: '新增维修记录',
				keepAlive: false
			}
		},
		{
			path: '/customer',
			name: 'customer',
			component: () => import('@/components/faqi/customer.vue'),
			meta: {
				title: '客户管理',
				keepAlive: false
			}
		},
		{
			path: '/add-customer',
			name: 'add-customer',
			component: () => import('@/components/faqi/add-customer.vue'),
			meta: {
				title: '新增编辑客户',
				keepAlive: false
			}
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: () => import('@/components/faqi/index.vue'),
			meta: {
				title: '首页',
				keepAlive: false
			}
		},
	]
})